<template>
  <div
    :id="source"
    class="flex flex-row gap-2 items-center cursor-pointer w-fit"
    @click="handleBack"
  >
    <ThemeImage
      :class="`size-${size}`"
      :icon="variants[variant].src"
      :alt="variants[variant].alt"
    />

    <span
      v-if="showText"
      class="text-[13px] proxima_nova secondary_color font-normal"
    >
      {{ text }}
    </span>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { imageNames } from "@/src/constants/imageConstants.js";
const router = useRouter();

const props = defineProps({
  source: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: "default",
  },
  route: {
    type: String,
    required: false,
  },
  showText: {
    type: Boolean,
    required: false,
    default: true,
  },
  text: {
    type: String,
    default: "Back",
  },
  useRouteOnly: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [String, Number],
    default: "4",
  },
});

const variants = {
  default: {
    src: imageNames.BACK_ARROW_DEFAULT_GREY,
    alt: "default_back_arrow",
  },
  variant1: {
    src: imageNames.BACK_ARROW_VARIANT1_GREY,
    alt: "variant1_back_arrow",
  },
  variant2: { src: imageNames.LEFT_ARROW, alt: "variant2_back_arrow" },
  variant3: { src: imageNames.LEFT_ARROW_WHITE, alt: "variant3_back_arrow" },
};

const handleBack = () => {
  if (props.useRouteOnly) {
    if (!props.route) {
      console.error(
        "BackButton: route prop is required when useRouteOnly is true",
      );
      return;
    }

    try {
      router.push(props.route);
    } catch (error) {
      console.error("Navigation error:", error);
      // Fallback to window.location if router fails
      window.location.href = props.route;
    }
    return;
  }

  const canUseRouter =
    router &&
    router.options &&
    router.options.history &&
    router.options.history.state;

  if (canUseRouter) {
    try {
      if (
        router.options.history.state.back &&
        router.options.history.state.back !== "/search"
      ) {
        router.back();
      } else {
        router.push(props.route);
      }
    } catch (error) {
      console.error("Router navigation failed:", error);
      if (props.route) {
        window.location.href = props.route;
      } else {
        window.history.back();
      }
    }
  } else {
    if (props.route) {
      window.location.href = props.route;
    } else {
      window.history.back();
    }
  }
};
</script>
